import { action, computed, makeObservable } from 'mobx'

import MapBoxViewerStore from '~/client/src/shared/components/MapBoxViewer/MapBoxViewer.store'
import { IMapSettings } from '~/client/src/shared/components/MapBoxViewer/mapSettings'

import { IMapControlsStore } from './IMapControlsStore'
import { Projection } from './MapControlsStore'

export default class MapBoxViewerAdapter implements IMapControlsStore {
  public constructor(private readonly store: MapBoxViewerStore) {
    makeObservable(this)
  }

  public getMap(): mapboxgl.Map | null {
    return this.store.mapRef?.getMap?.() ?? null
  }

  // A subscription, not a one-shot: a recovery replaces the instance (STX1-1068).
  public onMapReady(callback: (map: mapboxgl.Map) => void): () => void {
    const dispose = this.store.onMapChange(map => map && callback(map))
    const map = this.getMap()
    if (map) {
      callback(map)
    }

    return dispose
  }

  public resetViewport(): void {
    this.store.setViewportFromAddress()
  }

  public flyTo(longitude: number, latitude: number, zoom?: number): void {
    const map = this.getMap()
    if (!map) return
    map.flyTo({
      center: [longitude, latitude],
      zoom: zoom ?? map.getZoom(),
      duration: 800,
      essential: true,
    })
  }

  @action.bound
  public toggleProjection(): void {
    this.store.toggleProjection()
  }

  @computed
  public get projection(): Projection {
    return this.store.projection as Projection
  }

  @computed
  public get mapSettings(): IMapSettings {
    return this.store.mapSettings
  }
}
